/*
  If error.response is undefined this can be cause by a middleware error in Laravel, e.g. 429 too many requests - throttling
  General Laravel/Server errors are available through error.response.data.message
  Validation errors are be available through error.response.data.errors
*/

export default {
  state: {
    /*
      Used when front end validation mirrors laravel validation
      General errors, and custom errors (custom errors are sending responses via 'message' key,
      same key used for general errors) are displayed on the following forms/components:
        * Login.vue - Custom: UserController@login ** invalid credentials | JWT errors **
        * PasswordReset.vue - Custom: PasswordResetController@reset, but should never render in a browser
    */
    general: {
      active: false,
      message: ''
    },
    /*
      Used when front end validation does not mirror laravel validation
      Laravel validation is being displayed on the following forms/components:
        * Register.vue - ** email: unique | firstname: regex | lastname: regex **
        * Parent/CreateStudent.vue - ** firstname: regex | lastname: regex **
        * Parent/EditStudent.vue - ** firstname: regex | lastname: regex **
        * Admin/notifications/CreateForm.vue - ** message: regex | type: regex | active: boolean **
        * Admin/notifications/EditForm.vue - ** message: regex | type: regex | active: boolean **
        * Admin/courses/EditForm.vue - ** restrictions: regex,nullable | 10 other fields: required **
        * Admin/semesters/EditForm.vue - ** name: required | unique | regex  **
    */
    validation: {
      active: false,
      messages: []
    },
    invalidToken: false
  },
  mutations: {
    setGeneralErrors (state, errors) {
      state.general.active = true

      if (!errors.response) {
        state.general.message = 'Whoops! looks like something went wrong. Please try again. (in error.js)'
      } else {
        state.general.message = errors.response.data.message
      }

    },
    setValidationErrors (state, errors) {
      state.validation.active = true

      if (!errors.response) {
        state.validation.messages = [[ 'Whoops!! looks like something went wrong. Please try again. (in error.js)' ]]
      } else if (!errors.response.data.errors) {
        state.validation.messages = [[ errors.response.data.message ]]
      } else {
        state.validation.messages = errors.response.data.errors
      }
    },
    clearErrors(state) {
      state.general.active = false
      state.general.message = ''

      state.validation.active = false
      state.validation.messages = []
    },
    setTokenStatus(state, status) {
      state.invalidToken = status
    }
  },
  actions: {
    checkToken({ commit }, errors) {
      // all JWT errors are 401, most common reason for this to trigger is an expired token (1 hour lifespan)
      return new Promise((resolve, reject) => {
        if (errors.response.status === 401) {
          commit('setTokenStatus', true)
          // returns a pending promise, but leaving out a reject() doesn't trigger uncaught Promise error in console
          // passing Promise.resolve() in else block still returns a resolved promise in if block - weird behavior
        } else {
          resolve()
        }
      })

    }
  }

}


